import { Environment } from './environment';

export const environment: Environment = {
  mode: 'staging',
  apiBaseUrl: 'https://api.aeb-stage.netformic.cloud',
  kirbyBaseUrl:  'https://aeb-stage.netformic.cloud',
};
